import { inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LangService {
  private translate = inject(TranslateService);
  private readonly storageKey = 'app_lang';
  private readonly supported = ['ru', 'uz'] as const;
  private _langs = signal<'ru' | 'uz'>('uz');
  private currentLang = signal<string>('ru');
  currentLang$ = this.currentLang.asReadonly();
  init() {
    this.translate.addLangs(this.supported as any);
    const saved = localStorage.getItem(this.storageKey);
    const browser = this.normalize(this.translate.getBrowserLang());
    const toUse = this.normalize(saved) ?? browser ?? 'ru';
    this.use(toUse as 'ru' | 'uz');
  }
  use(lang: string) {
    const normalized = this.normalize(lang) ?? 'ru';
    this._langs.set(normalized as 'ru' | 'uz');
    this.translate.use(normalized);
    localStorage.setItem(this.storageKey, normalized);
    document.documentElement.setAttribute('lang', normalized);
    this.currentLang.set(normalized);
  }

  languages() {
    return [
      { code: 'ru', label: 'Русский' },
      { code: 'uz', label: 'O`zbek' },
    ];
  }
  private normalize(lang?: string | null) {
    if (!lang) return null;
    const short = lang.toLowerCase().slice(0, 2);
    return this.supported.includes(short as any) ? short : null;
  }
}
